import { getScript } from 'ui-helpers';

const showPayPalCalculator = () => {
  const params = new URLSearchParams(window.location.search);
  const paypalClientId = window.pageContextJavascript.paypalClientId || '';
  if (params.get('source') === 'paypal' && paypalClientId !== '') {
    getScript(`https://www.paypal.com/sdk/js?client-id=${paypalClientId}&components=messages`).then(() => {
      const { paypal } = window;
      const modal = paypal.MessagesModal({});
      modal.updateProps({
        amount: 100,
        offer: 'PAY_LATER_LONG_TERM',
      });

      modal.show();
    });
  }
};
export default showPayPalCalculator;
